export const UPDATE_SUBSCRIPTION_PLAN = "UPDATE_SUBSCRIPTION_PLAN";
export const UPDATE_SUBSCRIPTION_RECURRING_MODE = "UPDATE_SUBSCRIPTION_RECURRING_MODE";
export const UPDATE_SUBSCRIPTION_NEXT_BILLING_DATE = "UPDATE_SUBSCRIPTION_NEXT_BILLING_DATE";
